export default "/images/vendor/flag-icons/flags/1x1/ba.svg?705b1348460b1291d9373798b0d2993e";